<template>
    <div class="h-screen relative">
        <div class="md:text-left absolute left-0 px-4 bottom-0">
            <div v-if="isDevelopment">
                <h2>{{ error!.statusCode }}</h2>
                <p>{{ error!.message }}</p>
            </div>
        </div>
        <img
            :src="wallpaper"
            alt="Wallpaper"
            class="relative md:absolute top-0 left-0 h-1/2 lg:h-[calc(100vh-40px)] w-auto"
        />
        <div class="relative md:absolute px-4 md:top-1/2 md:-translate-y-1/2 md:right-10">
            <AppTitle large class="text-primary md:text-right">Lost at Sea</AppTitle>
            <AppSubtitle class="my-5"> Let's head back to safer shores.</AppSubtitle>

            <div class="flex md:justify-end items-center mt-3">
                <AppButton @click="$router.push('/')">Go back</AppButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import wallpaper from 'assets/img/illustration.png';

    import type { NuxtError } from '#app';

    const isDevelopment = computed(() => import.meta.env.VITE_MODE === 'development');

    defineProps({
        error: Object as () => NuxtError,
    });
</script>
